import { serviceWorkerReady } from '../pwa';

export const getSubscription = async (): Promise<PushSubscription | null> => {
  const registration = await serviceWorkerReady();

  return registration?.pushManager?.getSubscription() ?? null;
};

export const subscribe = async (applicationServerKey: string): Promise<PushSubscription | null> => {
  const registration = await serviceWorkerReady();

  if (!registration?.pushManager) {
    return null;
  }

  const subscription = await registration.pushManager.getSubscription();

  return (
    subscription ??
    registration.pushManager.subscribe({
      applicationServerKey,
      userVisibleOnly: true,
    })
  );
};

export const unsubscribe = async (subscription: PushSubscription): Promise<boolean> => subscription.unsubscribe();
